import React, { useState, useEffect } from "react";
import "./newlaunchingruko.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Cardrukolaunching from "./cardrukolaunching.jsx";

const Newlaunchingruko = ({ mobileFlyerR, desktopFlyerR }) => {
  const wapromo = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(launching+ruko)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="newlaunch-ruko" className="bannerhut">
      <div className="header">COMING SOON LAUNCHING RUKO</div>
      <div className="container-banner">
        <img
          src={isMobile ? mobileFlyerR : desktopFlyerR}
          alt="newlaunching-ruko"
        />
      </div>
      <div className="button-wa-promo">
        <button onClick={wapromo} className="whatsapp">
          <FontAwesomeIcon icon={faWhatsapp} /> Get More Info
        </button>
      </div>
      {/* <Cardrukolaunching /> */}
      <div className="containercard"></div>
    </div>
  );
};

export default Newlaunchingruko;
